export default __webpack_public_path__ + "static/media/extra.67328ac5.svg";